/* facets.js — collection/search filtering, sort, pills, load-more.
   Progressive enhancement: the facet form works server-side without JS; this
   intercepts it and re-renders via the Section Rendering API (no full reload).
   "Top rated" is a client-side sort by the Judge.me rating metafield. */
(function () {
  'use strict';

  function getSectionId() {
    var form = document.querySelector('[data-facet-form]');
    return form ? form.getAttribute('data-section-id') : null;
  }

  function sectionUrl(url) {
    var id = getSectionId();
    var u = new URL(url, window.location.origin);
    if (id) u.searchParams.set('section_id', id);
    return u.toString();
  }

  function clientSortActive() {
    var sel = document.querySelector('[data-sort]');
    if (!sel) return null;
    var opt = sel.options[sel.selectedIndex];
    return opt && opt.hasAttribute('data-client-sort') ? sel.value : null;
  }

  function maybeClientSort() {
    if (!clientSortActive()) return;
    var grid = document.querySelector('[data-product-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));
    cards.sort(function (a, b) {
      return parseFloat(b.getAttribute('data-rating') || 0) - parseFloat(a.getAttribute('data-rating') || 0);
    });
    cards.forEach(function (c) { grid.appendChild(c); });
  }

  // Auto-load: click the load-more button when it nears the viewport
  var loadMoreObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var btn = entry.target.querySelector('[data-load-more]');
      if (btn && !btn.classList.contains('is-loading')) btn.click();
    });
  }, { rootMargin: '700px 0px' }) : null;

  function observeLoadMore() {
    if (loadMoreObserver) {
      var wrap = document.querySelector('.coll-loadmore');
      if (wrap && wrap.querySelector('[data-load-more]')) loadMoreObserver.observe(wrap);
    }
  }

  function setBusy(on) {
    var results = document.querySelector('.coll-results');
    if (results) results.classList.toggle('is-loading', on);
  }

  function render(url, push) {
    setBusy(true);
    fetch(sectionUrl(url))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-collection-section]');
        var cur = document.querySelector('[data-collection-section]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        if (push !== false) window.history.pushState({ facet: true }, '', url);
        maybeClientSort();
        observeLoadMore();
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { setBusy(false); });
  }

  function urlFromForm(form) {
    var params = new URLSearchParams(new FormData(form));
    // drop empties
    var clean = new URLSearchParams();
    params.forEach(function (v, k) { if (v !== '' && v != null) clean.append(k, v); });
    // "Top rated" is client-side only — don't send it to Shopify
    if (clean.get('sort_by') === 'rating') clean.delete('sort_by');
    var qs = clean.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facet-form]');
    if (!form) return;
    // pure client sort (no fetch) when only the sort changed to a client option
    if (e.target.matches('[data-sort]') && clientSortActive()) {
      maybeClientSort();
      return;
    }
    render(urlFromForm(form), true);
  });

  // Pills + clear-all (server links) → intercept to re-render
  document.addEventListener('click', function (e) {
    var toTop = e.target.closest('[data-back-to-top]');
    if (toTop) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    var link = e.target.closest('[data-facet-link]');
    if (link) { e.preventDefault(); render(link.getAttribute('href'), true); return; }

    var more = e.target.closest('[data-load-more]');
    if (more) {
      e.preventDefault();
      var url = more.getAttribute('href');
      more.classList.add('is-loading');
      fetch(sectionUrl(url))
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var freshGrid = doc.querySelector('[data-product-grid]');
          var grid = document.querySelector('[data-product-grid]');
          if (freshGrid && grid) {
            Array.prototype.slice.call(freshGrid.children).forEach(function (c) { grid.appendChild(c); });
          }
          var freshMore = doc.querySelector('.coll-loadmore');
          var curMore = document.querySelector('.coll-loadmore');
          if (curMore) { if (freshMore) { curMore.replaceWith(freshMore); } else { curMore.remove(); } }
          maybeClientSort();
          observeLoadMore();
        })
        .catch(function () { window.location.href = url; });
    }
  });

  window.addEventListener('popstate', function () {
    if (document.querySelector('[data-collection-section]')) render(window.location.href, false);
  });

  // initial (covers a deep-linked "rating" choice)
  maybeClientSort();
  observeLoadMore();
})();
